// import img1 from '../Assets/CarouselImages/20.png'
import img2 from '../Assets/CarouselImages/1.jpg'
// import img3 from '../Assets/CarouselImages/22.png'
import img4 from '../Assets/CarouselImages/12.jpg'
// import img5 from '../Assets/CarouselImages/18.png'
// import img6 from '../Assets/CarouselImages/19.png'
import img7 from '../Assets/CarouselImages/15.png'
import img8 from '../Assets/CarouselImages/11.jpg'
// import img9 from '../Assets/CarouselImages/6.jpg'
import new1 from '../Assets/CarouselImages/new1.jpg'
import new2 from '../Assets/CarouselImages/new2.jpg'
import new3 from '../Assets/CarouselImages/new3.png'
import new4 from '../Assets/CarouselImages/new4.jpg'
import new5 from '../Assets/CarouselImages/new5.png'
import newsha from '../Assets/CarouselImages/newsha.png'

export const homeCardDetails = [
  { imgUrl: new1, title: 'Text 1' },
  { imgUrl: img2, title: 'Text 2' },
  { imgUrl: new2, title: 'Text 3' },
  { imgUrl: img4, title: 'Text 4' },
  { imgUrl: new3, title: 'Text 5' },
  { imgUrl: new4, title: 'Text 6' },
  { imgUrl: img7, title: 'Text 7' },
  { imgUrl: img8, title: 'Text 1' },
  { imgUrl: newsha, title: 'Text 2' },
  { imgUrl: new5, title: 'Text 2' },
]
